export default __webpack_public_path__ + "static/media/logo-white.fbf6293a.png";